export const filtrarComprobantes = (archivos, cadena) => {
  return archivos.filter((item) => item.pathS3.includes(cadena));
};

export const filtrarDocumentos = (archivos) => {
  return archivos.filter(
    (item) =>
      !item.pathS3.includes('comprobanteingreso') &&
      !item.pathS3.includes('facturaservicios')
  );
};
